// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__t0RCw","loader":"Loader_loader__JMA6t","spin":"Loader_spin__OuRD1"};